import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { api, formatPrice, formatDate, ORDER_STATUS } from "../lib/api";
import { useSeo } from "../lib/hooks";

const STEPS = ["payee", "en_preparation", "expediee", "livree"];

export default function OrderTrack() {
  useSeo({ title: "Suivi de commande" });
  const { orderNumber } = useParams();
  const [sp] = useSearchParams();
  const [o, setO] = useState(null);
  useEffect(() => {
    api.get(`/orders/track/${orderNumber}`, { params: { t: sp.get("t") || "" } }).then((r) => setO(r.data)).catch(() => setO(false));
  }, [orderNumber, sp]);
  if (o === null) return <p className="py-32 text-center eyebrow">Chargement…</p>;
  if (!o) return <div className="py-32 text-center"><p className="font-display text-3xl">Commande introuvable</p><Link to="/compte" className="btn-outline-gold mt-8">Mon compte</Link></div>;
  const idx = STEPS.indexOf(o.status === "prete_retrait" ? "expediee" : o.status);
  return (
    <div className="max-w-2xl mx-auto px-5 py-16" data-testid="order-track-page">
      <p className="eyebrow mb-3">Suivi de commande</p>
      <h1 className="font-display text-4xl" data-testid="track-order-number">{o.order_number}</h1>
      <p className="text-sm text-[#F8F6F1]/55 mt-2">{formatDate(o.created_at)} · {o.shipping.label}</p>
      <p className="mt-6 inline-block border border-[#C9A45C] px-4 py-2 text-[#C9A45C] text-sm tracking-wider" data-testid="track-status">{ORDER_STATUS[o.status]}</p>
      {idx >= 0 && (
        <div className="mt-8 grid grid-cols-4 gap-2">
          {STEPS.map((s, i) => (
            <div key={s}><div className={`h-1 ${i <= idx ? "bg-[#C9A45C]" : "bg-[#242424]"}`} /><p className={`mt-2 text-[10px] uppercase tracking-[0.15em] ${i <= idx ? "text-[#C9A45C]" : "text-[#F8F6F1]/35"}`}>{s === "expediee" && o.shipping.method === "retrait" ? "Prête" : ORDER_STATUS[s]}</p></div>
          ))}
        </div>
      )}
      {(o.tracking_number || o.carrier) && (
        <div className="mt-8 border border-[#C9A45C]/25 p-5 text-sm" data-testid="track-shipping-info">
          <p>Transporteur : {o.carrier || "—"}</p><p>Numéro de suivi : {o.tracking_number || "—"}</p>
          {o.tracking_url && <a href={o.tracking_url} target="_blank" rel="noopener noreferrer" className="btn-gold mt-4 !py-3" data-testid="track-link">Suivre mon colis</a>}
        </div>
      )}
      <div className="mt-8 divide-y divide-[#C9A45C]/10">
        {o.items.map((i) => <div key={i.product_id} className="py-3 flex justify-between text-sm"><span>{i.name} × {i.quantity}</span><span>{formatPrice(i.price * i.quantity)}</span></div>)}
        {o.discount > 0 && <div className="py-3 flex justify-between text-sm text-[#C9A45C]"><span>Réduction</span><span>−{formatPrice(o.discount)}</span></div>}
        <div className="py-3 flex justify-between text-sm" data-testid="track-shipping-line"><span>{o.shipping.label}</span><span>{o.shipping_cost > 0 ? formatPrice(o.shipping_cost) : "Gratuit"}</span></div>
        {o.shipping.relay_point && <p className="py-3 text-xs text-[#F8F6F1]/60" data-testid="track-relay">Point relais : {o.shipping.relay_point.name}, {o.shipping.relay_point.address}, {o.shipping.relay_point.postal_code} {o.shipping.relay_point.city}</p>}
        <div className="py-3 flex justify-between font-display text-2xl text-[#C9A45C]"><span>Total</span><span>{formatPrice(o.total)}</span></div>
      </div>
    </div>
  );
}
